
/**
 * Component for triggering the InfoPopup, and setting its content, by dispatching a "showInfoPopup" event.
 */
export function InfoTrigger(props: InfoTriggerProps)
{
    function handleClick()
    {
        const ce = new CustomEvent("showInfoPopup", {detail: props.children});
        document.dispatchEvent(ce); // Trigger the popup
    }

    return <sup className='ernots_InfoTrigger' onClick={handleClick}>?</sup>;
}

interface InfoTriggerProps
{
    children: React.ReactNode; // Content to display in the popup
}
